module.exports = __webpack_public_path__ + "static/media/schools-banner.f9f67b20.jpg";